module.exports = __webpack_public_path__ + "img/9788960511811.4b41ffb0.jpg";